/* eslint-disable camelcase */

/* eslint-disable max-len */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import Strengths from '../../assets/Brain.png';
import DiscussionLogs from '../../assets/friend.png';
import { ROLES } from '../../constants';
import { useGetAssociatePcQuery } from '../../features/coaching/coachingSlice';
import NewConversationLog from '../../features/coaching/conversationLogs/newConversationLog/NewConversationLog';
import { EmployeeSearchPopUp } from '../../features/coaching/employeeSearchPopUp/EmployeeSearchPopUp';
import { SearchedEmployeType } from '../../features/coaching/revGen/type';
import NewStrength from '../../features/coaching/strengths/newStrength/NewStrength';
import {
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectCurrentUserNameWithId,
} from '../../pages/login/authSlice';
import { datetimeToDate } from '../../utils/dateFormat';
import { CoachingEntityTypes, CoachingTabs } from '../../utils/typeConstants';
import CoachingToDo from '../CoachingToDo/CoachingToDo';
import { CoachingInsightSummary, InsightSummaryRef } from '../coachingInsightSummary/CoachingInsightSummary';
import { ThumbDownFeedback } from '../coachingInsightSummary/ThumbDownFeedback';
import CoachingShoutOut from '../coachingShoutOut/coachingShoutOUt';
import MessageInfo from '../messageInfo/MessageInfo';
import { useGetCoachingInsightSummaryQuery, useGetInsightCallDetailsQuery, useGetCoachingInsightConfigQuery } from './CoachingInsightSlice';
import { CopyConfirmationDialog } from './CopyConfirmationDialog';
import { CoachingInsightHistory } from './coachingInsightHistory/CoachingInsightHistory';
import { CoachingInsightCallDetailsTable } from './coachingInsightCallDetailsTable/CoachingInsightCallDetailsTable';

interface coachingInsightProps {
    selectedTLList?: any;
    selectedParentClient?: any;
    selectedManager?: any;
    fromTab?: string;
    data_aggregation_period?: 'weekly' | 'monthly'; // Add aggregation period flag
}

export const CoachingInsight = ({
    selectedTLList,
    selectedParentClient,
    selectedManager,
    fromTab,
    data_aggregation_period = 'weekly', // Default to weekly
}: coachingInsightProps) => {
    const [selectedAgent, setSelectedAgent] = useState<any>(null);
    const [selectedAgentName, setSelectedAgentName] = useState<any>(null);
    const [selectedEmpList, setSelectedEmpList] = useState<any>([]);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [enableSummariseButton, setEnableSummariseButton] = useState<boolean>(false);
    const [isSummarise, setIsSummarise] = useState<any>();
    const [isCurrentWeek, setIsCurrentWeek] = useState<boolean>(false);
    const [selectedTeam, setSelectedTeam] = useState<any>();
    const [selectedTeamLead, setSelectedTeamLead] = useState<any>();
    const [selectedTeamLeadList, setSelectedTeamLeadList] = useState<any>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const [dates, setDates] = useState<Date[] | null>(null);
    const [selectedMonth, setSelectedMonth] = useState<Date | null>(null);
    const [shoutoutVisible, setShoutoutVisible] = useState(false);
    const [todoVisible, setTodoVisible] = useState(false);
    const [viewState, setViewState] = useState<string>('new');
    const [showNewConversationModal, setshowNewConversationModal] = useState(false);
    const [showNewStrengthModal, setShowNewStrengthModal] = useState(false);
    const loggedUser = useSelector(selectCurrentEmpid);
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [insightsData, setInsightsData] = useState<any>([]);
    const [insightFeedbackData, setInsightFeedbackData] = useState<any>([]);
    const [disagreeFeedback, setDisagreeFeedback] = useState<string>('');
    const insightSummaryRef = useRef<InsightSummaryRef | null>(null);
    const [thumbdownFeedbackColumn, setThumbdownFeedbackColumn] = useState<string>('new');
    const [showInsightsHistoryModal, setShowInsightsHistoryModal] = useState<boolean>(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const [currentAction, setCurrentAction] = useState<string>('');
    const [dialogVisible, setConfirmDialogVisible] = useState<boolean>(false);
    const [dialogHeader, setDialogHeader] = useState<string>('');
    const [dialogBody, setDialogBody] = useState<string>('');
    const [copyConfirmed, setCopyConfirmed] = useState<boolean | null>(null);
    const [coachingPoints, setCoachingPoints] = useState<any>(''); // eslint-disable-line
    const [strengths, setStrengths] = useState<any>('');
    const [actionBody, setActionBody] = useState<string>('');
    const [isSearchClicked, setIsSearchClicked] = useState<boolean>(false);
    const [callDetailsData, setCallDetailsData] = useState<any>([]);
    const loggedUserWithId = useSelector(selectCurrentUserNameWithId);
    const [showActionItems, setShowActionItems] = useState<boolean>(false);

    // Function to trigger the onThumbsDownSave in CoachingInsightSummary
    const triggerInsightSummarySaveFunction = (feedbackColumn: string) => {
        if (insightSummaryRef.current) {
            insightSummaryRef.current.onThumbsDownSave(feedbackColumn); // Call the method from CoachingInsightSummary
            setShowThumbDownFeedback(false);
        }
    };

    const [searchedEmployee, setSearchedEmployee] = useState<SearchedEmployeType>({
        employee_name: '',
        employee_number: '',
        location: '',
        job_title: '',
    });
    const teamOptions = [
        { name: 'My Team', code: 'myTeam' },
        { name: 'Search', code: 'search' },
    ];
    const [showThumbDownFeedback, setShowThumbDownFeedback] = useState<boolean>(false);

    const { data: insightSummaryData, isFetching: isSummaryFetching } = useGetCoachingInsightSummaryQuery(
        {
            agentNumber: ROLES.Agents.includes(userManagerLevel) ? loggedUser : selectedAgent?.toString(),
            fromDate: dates?.[0] ? datetimeToDate(dates[0]) : null,
            toDate: dates?.[1] ? datetimeToDate(dates[1]) : null,
            isCurrentWeek,
            parentClientId: selectedParentClient?.[0],
        },
        {
            skip: !isSummarise,
        }
    );
    const { data: insightCallDetailsData, isFetching: isCallDetailsFetching } = useGetInsightCallDetailsQuery(
        {
            agentNumber: ROLES.Agents.includes(userManagerLevel) ? loggedUser : selectedAgent?.toString(),
            fromDate: dates?.[0] ? datetimeToDate(dates[0]) : null,
            toDate: dates?.[1] ? datetimeToDate(dates[1]) : null,
        },
        {
            skip: !isSearchClicked,
        }
    );

    const { data: directAssociate } = useGetAssociatePcQuery(
        {
            managerNumber: ROLES.Supervisor2AndAbove.includes(userManagerLevel)
                ? parseInt(selectedManager, 10)
                : '',
            tlNumber: ROLES.Supervisor2AndAbove.includes(userManagerLevel)
                ? selectedTeamLead
                : parseInt(loggedEmpNum, 10),
            parentClientIds: selectedParentClient,
        },
        {
            skip: !loggedEmpNum, //|| !selectedParentClient,
        }
    );

    // Fetch coaching insight config to get show_action_items flag
    const { data: coachingInsightConfig } = useGetCoachingInsightConfigQuery(
        {
            parentClientId: selectedParentClient?.[0],
        },
        {
            skip: !selectedParentClient || selectedParentClient.length === 0,
        }
    );
    useEffect(() => {
        setInsightsData([]);
        setIsSummarise(false);
        if (!isSummaryFetching && insightSummaryData?.data) {
            setInsightsData(insightSummaryData);
            setCoachingPoints(insightSummaryData?.data[0]?.negativeTips);
            setStrengths(insightSummaryData?.data[0]?.positiveTips);
        }
    }, [insightSummaryData]);

    // Set showActionItems flag from config
    useEffect(() => {
        if (coachingInsightConfig?.data) {
            setShowActionItems(coachingInsightConfig.data.show_action_items ?? false);
        } else {
            setShowActionItems(false);
        }
    }, [coachingInsightConfig]);
    useEffect(() => {
        setCallDetailsData([]);
        setIsSearchClicked(false);
        if (!isCallDetailsFetching && insightCallDetailsData?.data) {
            setCallDetailsData(insightCallDetailsData);
        }
    }, [insightCallDetailsData]);

    useEffect(() => {
        if (selectedTeam !== '') {
            if (!localStorage.getItem('insightsSelectedAgent')) {
                setSelectedAgent(null);
                setSelectedAgentName('');
                setInsightsData([]);
            }
        }
        if (selectedTeam === 'search') {
            const storedEmployee = localStorage.getItem('insightsSearchedEmployee');
            if (storedEmployee) {
                setSearchedEmployee(JSON.parse(storedEmployee));
            } else {
                setVisible(true);
            }
        }
    }, [selectedTeam]);

    useEffect(() => {
        if (directAssociate?.data?.length > 0) {
            const employeeNames = directAssociate.data.map((employee: any) => ({
                label: employee.employee_name,
                value: employee.employee_number,
            }));
            setSelectedEmpList(employeeNames);
            if (
                localStorage.getItem('insightsSelectedAgent') &&
                employeeNames.some(
                    (item: any) => item.value === localStorage.getItem('insightsSelectedAgent')
                )
            ) {
                setSelectedAgent(localStorage.getItem('insightsSelectedAgent'));
            }
        } else {
            setSelectedEmpList([]);
            setSelectedAgent(null);
        }
    }, [directAssociate]);

    useEffect(() => {
        const selectedTL = localStorage.getItem('insightsSelectedTL');
        if (selectedTLList?.data?.length > 0) {
            setSelectedTeamLeadList(selectedTLList?.data);
            if (
                selectedTL &&
                selectedTLList?.data?.some((item: any) => item.employee_number === selectedTL)
            ) {
                setSelectedTeamLead(selectedTL);
            }
        } else {
            setSelectedTeamLeadList([]);
            setSelectedTeamLead(null);
        }
    }, [selectedTLList]);

    useEffect(() => {
        if (searchedEmployee?.employee_number) {
            localStorage.setItem('insightsSearchedEmployee', JSON.stringify(searchedEmployee));
            setSelectedAgent(searchedEmployee?.employee_number);
            setSelectedAgentName(searchedEmployee?.employee_name);
            setSelectedTeam('');
        }
    }, [searchedEmployee]);
    useEffect(() => {
        const selectedTeam = localStorage.getItem('insightsSelectedTeam');
        if (selectedTeam && teamOptions.some((item: any) => item.code === selectedTeam)) {
            setSelectedTeam(selectedTeam);
        } else {
            setSelectedTeam('');
        }
    }, []);

    useEffect(() => {
        setEnableSummariseButton(false);
        setInsightsData([]);
        setCallDetailsData([]);
        if ((ROLES.Agents.includes(userManagerLevel) || selectedAgent) && dates && dates.length > 0) {
            setEnableSummariseButton(true);
        }
    }, [selectedAgent, dates]);
    useEffect(() => {
        setDates(null);
        setSelectedMonth(null);
        if (data_aggregation_period === 'weekly') {
            const savedDates = localStorage.getItem('insightsSelectedDateRange');
            if (savedDates) {
                const [startDate, endDate] = JSON.parse(savedDates).map((date: string) => new Date(date));
                setDates([startDate, endDate]);
            }
        } else if (data_aggregation_period === 'monthly') {
            const savedMonth = localStorage.getItem('insightsSelectedMonth');
            if (savedMonth) {
                const monthDate = new Date(savedMonth);
                setSelectedMonth(monthDate);
                // Set dates based on saved month
                const startDate = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
                const endDate = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);
                setDates([startDate, endDate]);
            }
        }
    }, [data_aggregation_period]);
    const handleDateChange = (e: any) => {
        const selectedDate = e.value instanceof Date ? e.value : e.value[0];
        if (selectedDate) {
            const dayOfWeek = selectedDate.getDay();
            const startDate = new Date(selectedDate);
            const endDate = new Date(selectedDate);
            const startOffset = dayOfWeek === 0 ? -6 : -dayOfWeek + 1;
            startDate.setDate(selectedDate.getDate() + startOffset);
            const endOffset = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
            endDate.setDate(selectedDate.getDate() + endOffset);
            setDates([startDate, endDate]);
            localStorage.setItem('insightsSelectedDateRange', JSON.stringify([startDate, endDate]));

            // const startDate = new Date(selectedDate);
            // const endDate = new Date(selectedDate);
            // endDate.setDate(selectedDate.getDate() + 7);
            // setDates([startDate, endDate]);
        }
    };

    const handleMonthChange = (e: any) => {
        const selectedDate = e.value;
        if (selectedDate) {
            setSelectedMonth(selectedDate);
            // Get first day of selected month
            const startDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
            // Get last day of selected month
            const endDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
            setDates([startDate, endDate]);
            localStorage.setItem('insightsSelectedMonth', selectedDate.toISOString());
        }
    };

    const renderThumbDownFeedback = () => {
        return (
            <Dialog
                visible={showThumbDownFeedback}
                style={{ width: '40vw', borderRadius: '12px' }}
                onHide={() => setShowThumbDownFeedback(false)}
            >
                <ThumbDownFeedback
                    insightFeedbackData={insightFeedbackData}
                    disagreeFeedback={disagreeFeedback}
                    setDisagreeFeedback={setDisagreeFeedback}
                    hideFunction={setShowThumbDownFeedback}
                    onButtonClick={triggerInsightSummarySaveFunction}
                    thumbdownFeedbackColumn={thumbdownFeedbackColumn}
                />
            </Dialog>
        );
    };
    const onAgentChange = (e: any) => {
        setSelectedAgent(e.value);
        localStorage.setItem('insightsSelectedAgent', e.value);
        const selectedOption = selectedEmpList.find((option: any) => option.value === e.value);
        if (selectedOption) {
            setSelectedAgentName(selectedOption.label);
        }
    };
    const renderStrenghtsModal = () => {
        return (
            <NewStrength
                OnViewState={setViewState}
                OnDisplayModal={setShowNewStrengthModal}
                displayModal={showNewStrengthModal}
                authorId={loggedEmpNum}
                authorName={loggedEmpUserName}
                recieverId={selectedAgent}
                receiverName={selectedAgentName}
                parentStrengthViewState={'new'}
                via={CoachingTabs.CoachingInsights}
                month={dates?.[0] ? dates[0].getMonth() + 1 : undefined}
                year={dates?.[0] ? dates[0].getFullYear() : undefined}
                coachingEntityId={insightsData?.data[0]?.coachingInsightId}
                coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                strengthDesc={actionBody}
            />
        );
    };
    const renderCallInsightsHistory = () => {
        return (
            <CoachingInsightHistory
                agentNumber={ROLES.Agents.includes(userManagerLevel) ? loggedUser : selectedAgent?.toString()}
                showInsightsHistoryModal={showInsightsHistoryModal}
                setShowInsightsHistoryModal={setShowInsightsHistoryModal}
            />
        );
    };
    const renderDiscussionModal = () => {
        return (
            <NewConversationLog
                setViewState={setViewState}
                setDisplayModal={setshowNewConversationModal}
                viewState={viewState}
                displayModal={showNewConversationModal}
                authorId={loggedUser}
                authorName={loggedEmpUserName}
                recieverId={selectedAgent}
                receiverName={selectedAgentName}
                via={CoachingTabs.CoachingInsights}
                coachingEntityId={insightsData?.data[0]?.coachingInsightId}
                coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                discussionDesc={actionBody}
            //getData={(data: any) => { handleGetData(data) }}
            />
        );
    };
    const renderTodoModal = () => {
        return (
            <CoachingToDo
                receiverId={ROLES.Agents.includes(userManagerLevel) ? loggedUser : selectedAgent}
                receiverName={ROLES.Agents.includes(userManagerLevel) ? loggedUserWithId : selectedAgentName}
                visible={todoVisible}
                setVisible={setTodoVisible}
                coachingEntityId={insightsData?.data[0]?.coachingInsightId}
                coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                coachingStatusId={1}
                todoDescription={actionBody}
            />
        );
    };
    const renderShuotOutModal = () => {
        return (
            <CoachingShoutOut
                receiverId={ROLES.Agents.includes(userManagerLevel) ? loggedUser : selectedAgent}
                receiverName={ROLES.Agents.includes(userManagerLevel) ? loggedUserWithId : selectedAgentName}
                visible={shoutoutVisible}
                setVisible={setShoutoutVisible}
                coachingEntityId={insightsData?.data[0]?.coachingInsightId}
                coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                coreValueId={0}
                shoutOutDescription={actionBody}
            />
        );
    };
    function getTextFromHTML(html: any) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.innerText.trim();
    }
    useEffect(() => {
        if (copyConfirmed !== null && copyConfirmed === false) {
            setActionBody('');
        }
        if (currentAction === 'Discussion') {
            if (copyConfirmed) {
                setActionBody(getTextFromHTML(coachingPoints));
            }
            if (copyConfirmed !== null) {
                setshowNewConversationModal(true);
            }
        } else if (currentAction === 'ToDo') {
            if (copyConfirmed) {
                setActionBody(getTextFromHTML(coachingPoints));
            }
            if (copyConfirmed !== null) {
                setTodoVisible(true);
            }
        } else if (currentAction === 'Strengths') {
            if (copyConfirmed) {
                setActionBody(getTextFromHTML(strengths));
            }
            if (copyConfirmed !== null) {
                setShowNewStrengthModal(true);
            }
        } else if (currentAction === 'ShoutOut') {
            if (copyConfirmed) {
                setActionBody(getTextFromHTML(strengths));
            }
            if (copyConfirmed !== null) {
                setShoutoutVisible(true);
            }
        }
        setCopyConfirmed(null);
    }, [copyConfirmed]);
    const handleAction = (action: string) => {
        if (action === 'Discussion') {
            setConfirmDialogVisible(true);
            setDialogHeader('Copy coaching Points?');
            setDialogBody('Do you want to copy the Coaching Points to the Discussion?');
        } else if (action === 'Strengths') {
            setConfirmDialogVisible(true);
            setDialogHeader('Copy Strengths?');
            setDialogBody('Do you want to copy the Strengths to the Strengths document?');
        } else if (action === 'ShoutOut') {
            setConfirmDialogVisible(true);
            setDialogHeader('Copy Strengths?');
            setDialogBody('Do you want to copy the Strengths into the Shout Out?');
        } else if (action === 'ToDo') {
            setConfirmDialogVisible(true);
            setDialogHeader('Copy coaching Points?');
            setDialogBody('Do you want to copy the Coaching Points to the To Do?');
        }
    };
    const handleButtonOnClick = (action: string) => {
        setCurrentAction(action);
        if (strengths === '') {
            if (action === 'Strengths' || action === 'ShoutOut') {
                setCopyConfirmed(false);
                return;
            }
        }
        if (coachingPoints === '') {
            if (action === 'Discussion' || action === 'ToDo') {
                setCopyConfirmed(false);
                return;
            }
        }
        handleAction(action);
    };

    const handleSummarize = () => {
        if (dates?.[0] && dates?.[1]) {
            const fromDate = new Date(dates[0]);
            const toDate = new Date(dates[1]);
            const today = new Date();

            if (today >= fromDate && today <= toDate) {
                setIsCurrentWeek(true);
            } else {
                setIsCurrentWeek(false);
            }
            setIsSummarise(true);
        }
    };

    return (
        <>
            <div className="row mt-2">
                {!ROLES.Agents.includes(userManagerLevel) && (
                    <div className="col-md-3">
                        {ROLES.Supervisor2AndAbove.includes(userManagerLevel) ? (
                            <div className="content">
                                <label htmlFor="TLSelection">Select Team Lead</label>
                                <Dropdown
                                    value={selectedTeamLead}
                                    onChange={(event) => {
                                        setSelectedTeamLead(event.target.value);
                                        localStorage.setItem('insightsSelectedTL', event.target.value);
                                        localStorage.removeItem('insightsSelectedAgent');
                                        setSelectedAgent(null);
                                    }}
                                    options={selectedTeamLeadList}
                                    optionLabel={'employee_name'}
                                    optionValue={'employee_number'}
                                    placeholder="Select Team Lead"
                                    className="custom-dropdown me-2"
                                    filter
                                />
                            </div>
                        ) : (
                            <div className="content">
                                <label htmlFor="TeamSelection">Select Team</label>
                                <Dropdown
                                    value={selectedTeam}
                                    onChange={(event) => {
                                        setSelectedTeam(event.target.value);
                                        localStorage.removeItem('searchedUser');
                                        localStorage.setItem('insightsSelectedTeam', event.target.value);
                                        localStorage.removeItem('insightsSelectedAgent');
                                        localStorage.removeItem('insightsSearchedEmployee');
                                    }}
                                    options={teamOptions}
                                    optionLabel={'name'}
                                    optionValue={'code'}
                                    placeholder="Select Team"
                                    className="custom-dropdown me-2"
                                />
                            </div>
                        )}
                    </div>
                )}
                {(selectedTeam === 'myTeam' || selectedTLList?.data?.length > 0) && (
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="AgentSelection">Select Associate</label>
                            <Dropdown
                                id="AssociateSelection"
                                filter
                                placeholder="Select Associate"
                                options={selectedEmpList}
                                optionValue={'value'}
                                optionLabel={'label'}
                                onChange={onAgentChange}
                                value={selectedAgent}
                                className="custom-dropdown me-2"
                            />
                        </div>
                    </div>
                )}
                {visible && (
                    <EmployeeSearchPopUp
                        visible={visible}
                        searchedEmployee={searchedEmployee}
                        setVisible={setVisible}
                        setSelectedTeam={setSelectedTeam}
                        setSearchedEmployee={setSearchedEmployee}
                    />
                )}
                {selectedTeam !== 'myTeam' && searchedEmployee?.employee_number && (
                    <div className="col-md-2">
                        <div className="content">
                            <label htmlFor="AgentSelection">Selected Associate</label>
                            <InputText
                                disabled
                                placeholder="Recipient"
                                className="w-100 borderRadius8"
                                value={searchedEmployee?.employee_name}
                            />
                        </div>
                    </div>
                )}
                <div className="col-md-3">
                    <div className="col">
                        <div className="content">
                            {data_aggregation_period === 'weekly' ? (
                                <>
                                    <label htmlFor="WeekSelection">Week</label>
                                    <Calendar
                                        value={dates}
                                        onChange={handleDateChange}
                                        selectionMode="range"
                                        dateFormat="dd-M-yy"
                                        readOnlyInput
                                        placeholder="Select a week"
                                        showIcon
                                        className="custom-calendar"
                                    />
                                </>
                            ) : (
                                <>
                                    <label htmlFor="MonthSelection">Month</label>
                                    <Calendar
                                        value={selectedMonth}
                                        onChange={handleMonthChange}
                                        view="month"
                                        dateFormat="M-yy"
                                        readOnlyInput
                                        placeholder="Select a month"
                                        showIcon
                                        className="custom-calendar"
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
                {fromTab === 'callDetails' ? (
                    <div className="col-md-3">
                        <div className="content" style={{ flexDirection: 'inherit' }}>
                            <Button
                                className="btn-primary"
                                style={{ marginTop: '31px' }}
                                onClick={() => setIsSearchClicked(true)}
                                disabled={
                                    !(
                                        (selectedAgent || ROLES.Agents.includes(userManagerLevel)) &&
                                        dates &&
                                        dates.length > 0
                                    )
                                }
                            >
                                Search
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div className="col-md-3">
                        <div className="content" style={{ flexDirection: 'inherit' }}>
                            <Button
                                className="btn-primary"
                                style={{ marginTop: '31px' }}
                                onClick={handleSummarize}
                                disabled={!enableSummariseButton}
                            >
                                Summarize
                            </Button>
                        </div>
                    </div>
                )}
            </div>
            {fromTab !== 'callDetails' && (
                <div className="row mt-4">
                    <div className="content">
                        <label htmlFor="CallCount">Call Count</label>
                        <label className=" ms-4">
                            {' '}
                            {insightSummaryData?.data[0]?.callCount
                                ? insightSummaryData?.data[0]?.callCount
                                : '--'}
                        </label>
                    </div>
                </div>
            )}
            <Divider />
            {insightsData?.data?.length > 0 && insightsData?.data[0]?.coachingInsightId >= 0 && (
                <CoachingInsightSummary
                    data={insightsData?.data}
                    disagreeFeedback={disagreeFeedback}
                    setShowThumbDownFeedback={setShowThumbDownFeedback}
                    setThumbdownFeedbackColumn={setThumbdownFeedbackColumn}
                    ref={insightSummaryRef}
                    setInsightFeedbackData={setInsightFeedbackData}
                    setShowInsightsHistoryModal={setShowInsightsHistoryModal}
                    showActionItems={showActionItems}
                />
            )}
            {insightsData?.data &&
                (insightsData?.data.length === 0 || insightsData?.data[0]?.coachingInsightId < 0) && (
                    <div className="col-12">
                        <MessageInfo
                            title="No results found."
                            message="Try adjusting the Week or Associate filter above."
                            rowHeight="200px"
                        />
                    </div>
                )}

            {showThumbDownFeedback && renderThumbDownFeedback()}
            {insightsData?.data?.length > 0 && insightsData?.data[0]?.coachingInsightId > 0 && (
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <div>
                        <Button
                            label="Shout Out"
                            className="btn-primary"
                            icon="pi pi-megaphone"
                            onClick={() => handleButtonOnClick('ShoutOut')}
                        // style={{ backgroundColor: '#3299ff', color: 'white', marginRight: '10px' }}
                        />
                        <Button
                            label="To Do"
                            icon="pi pi-comment"
                            onClick={() => handleButtonOnClick('ToDo')}
                            className="btn-primary me-2"
                        // style={{
                        //     backgroundColor: '#3299ff',
                        //     color: 'white',
                        //     whiteSpace: 'nowrap',
                        //     marginRight: '10px',
                        // }}
                        />
                        <Button
                            type="button"
                            className="btn-primary me-2"
                            // style={{
                            //     borderColor: '#3299FF',
                            //     color: '#3299FF',
                            //     height: '43px',
                            //     fontWeight: 'bold',
                            // }}
                            onClick={() => handleButtonOnClick('Discussion')}
                            hidden={ROLES.Agents.includes(userManagerLevel)}
                        >
                            <img src={DiscussionLogs} alt="DiscussionLogs" style={{ width: '22px' }} />
                            Discussion
                        </Button>
                        <Button
                            type="button"
                            className="btn-primary me-2"
                            // style={{
                            //     borderColor: '#3299FF',
                            //     color: '#3299FF',
                            //     height: '43px',
                            //     fontWeight: 'bold',
                            // }}
                            onClick={() => handleButtonOnClick('Strengths')}
                            hidden={ROLES.Agents.includes(userManagerLevel)}
                        >
                            <img
                                style={{
                                    filter: 'brightness(1) invert(1) sepia(3) saturate(20) hue-rotate(195deg)',
                                    width: '20px',
                                }}
                                src={Strengths}
                                alt="Strengths"
                            />
                            Strengths
                        </Button>
                    </div>
                </div>
            )}
            {showNewConversationModal && renderDiscussionModal()}
            {showNewStrengthModal && renderStrenghtsModal()}
            {todoVisible && renderTodoModal()}
            {shoutoutVisible && renderShuotOutModal()}
            <CopyConfirmationDialog
                dialogVisible={dialogVisible}
                setDialogVisible={setConfirmDialogVisible}
                dialogHeader={dialogHeader}
                dialogBody={dialogBody}
                setCopyConfirmed={setCopyConfirmed}
            />
            {showInsightsHistoryModal && renderCallInsightsHistory()}
            {fromTab === 'callDetails' && callDetailsData?.data && (
                <CoachingInsightCallDetailsTable callDetails={callDetailsData} />
            )}
        </>
    );
};
